import React from "react"

import Slider from "react-slick"

import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"

import "./deviceCarousel.scss"

const DeviceCarousel = (props) => {
  const NextArrow = ({ currentSlide, slideCount, ...props }) => (
    <div>
      <NavigateNextIcon {...props} />
    </div>
  )
  const PrevArrow = ({ currentSlide, slideCount, ...props }) => (
    <div>
      <NavigateBeforeIcon {...props} />
    </div>
  )

  const settings = {
    dots: false,
    arrows: true,
    lazyload: true,
    infinite: true,
    autoplay: false,
    draggable: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  return (
    <Slider {...settings} className={"device-carousel"}>
      {props.carousel.map((item, index) => {
        return (
          <img
            className={"device-carousel-picture"}
            key={index}
            src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${item.value.path}`}
            alt=""
          />
        )
      })}
    </Slider>
  )
}

export default DeviceCarousel
